import React from "react"
import { IThead } from "./interface"
import { TheadComponent } from "./style"

const Thead = ({
    children
}: IThead
): React.ReactElement => (
    <TheadComponent>
        { children }
    </TheadComponent>
)

export default Thead